import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import NavBar from '../../components/NavBarSearchSong';
import { Grid } from '@material-ui/core';
import { SvgList } from '../../components';
import search from '../../assets/ic_search.png';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Settings from '../../assets/Settings.png';
import { formatDateToDisplay } from '../../utils';
import SearchBox from '../../components/SearchBox';
import { withdrawalsServices } from '../../services';
import { set } from 'lodash';
import { withDrawalActions } from '../../actions';

function WithDrawals() {
  const history = useHistory();
  const [withdrawalServices, setWithdrawalServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchValue, setSearchValue] = useState('');

  const dataToRender = useMemo(() => {
    if (searchValue) {
      return withdrawalServices.filter((item) => item.title.toLowerCase().includes(searchValue.toLowerCase()));
    }
    return withdrawalServices;
  }, [searchValue, withdrawalServices]);

  useEffect(() => {
    // Fetch First 10 Songs
    const fetchAllWithdrawalsData = async () => {
      setIsLoading(true);
      const data = await withDrawalActions.fetchAllWithdrawals({
        page: 1,
        status: ['PENDING'],
      });
      console.log(data, 'data');

      setWithdrawalServices(data);
      setIsLoading(false);
    };
    fetchAllWithdrawalsData();
  }, []);

  return (
    <>
      <NavBar data="Withdrawals" icon={Settings} currentRouteName="Requests" breadcrumbsPath={[{ name: 'Withdrawals' }]} />
      <div className="content" style={{ marginTop: 73 }}>
        <div style={{ marginBottom: 12 }}>
          <SearchBox placeholder="Search song here..." onChange={(e) => setSearchValue(e)} />
        </div>

        <div style={{ width: '100%', flex: 1, overflow: 'hidden', height: '100%' }}>
          <TableContainer className="tbl_wraper tbl_wrap" style={{ height: '100%', margin: 0 }} component={Paper}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="table_font result">Result</TableCell>
                  <TableCell>Artist Name</TableCell>
                  <TableCell style={{ minWidth: 210 }}>Date Finished</TableCell>
                  <TableCell width={140}>Amount</TableCell>
                  <TableCell width={210}>Account Number</TableCell>
                  <TableCell className="action">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && (
                  <div className="table_initial_loader">
                    <CircularProgress />
                  </div>
                )}

                {dataToRender?.length === 0 && !isLoading ? (
                  <div className="table_initial_loader">
                    <h4
                      style={{
                        textAlign: 'center',
                        marginBottom: 20,
                        fontSize: 20,
                        lineHeight: '32px',
                        maxWidth: '60%',
                        marginInline: 'auto',
                      }}
                    >
                      No Withdrawals Found
                    </h4>
                  </div>
                ) : (
                  dataToRender?.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell className="result">#{++index}</TableCell>
                      <TableCell>{row.title}</TableCell>
                      <TableCell style={{ minWidth: 210 }}>{row.dateinitiated}</TableCell>

                      <TableCell width={140}>${row.amount}</TableCell>
                      <TableCell width={210}>{row.accountnumber}</TableCell>
                      <TableCell className="action">
                        <div style={{ cursor: 'pointer' }} onClick={() => history.push(`/artists/${row.user_id}?active=financials`)}>
                          <SvgList name="copylink-icon" />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
}
export default WithDrawals;

